import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

const Wrapper = styled.div`
  display: flex;
  flex-flow: column wrap;
  border: 2px solid ${({ theme }) => theme.colors.secondary};
  border-radius: 0.2rem;
  width: 100%;
  background-color: ${({ $backgroundColor }) =>
    $backgroundColor || "var(--color-white)"};
  color: ${({ $textColor }) => $textColor || "var(--color-black)"};
`;

export default function FaqWrapper({ children, backgroundColor, textColor }) {
  return (
    <Wrapper
      itemScope
      itemProp="mainEntity"
      itemType="https://schema.org/FAQPage"
      $backgroundColor={backgroundColor}
      $textColor={textColor}
    >
      {children}
    </Wrapper>
  );
}

FaqWrapper.propTypes = {
  children: PropTypes.node,
  backgroundColor: PropTypes.string,
  textColor: PropTypes.string,
};

FaqWrapper.defaultProps = {
  children: undefined,
};
